import { FaWhatsapp } from "react-icons/fa";

function WhatsAppButton() {
  return (
    <a
      href="https://web.whatsapp.com/send?phone=917016464911&text=Hello%2C%20I%20have%20an%20inquiry%20came%20from%20your%20website."
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300"
    >
      <FaWhatsapp size={30} />
    </a>
  );
}

export default WhatsAppButton;
